import client from '../client';
import type { ApiResponse } from '../../types/api';

// One section instance on a storefront page. Mirrors the public
// /api/v1/store/:storeId/sections response shape.
export interface PageSection {
  _id?: string; // present on read; ignored/regenerated on save
  name: string; // 'banner', 'products', 'footer', etc.
  variant: string;
  order: number;
  inputs: Record<string, unknown>;
  className?: string;
  hidden?: boolean;
  themeId?: string;
}

export const sectionsApi = {
  // Read the active version's sections for this page. noAB=1 skips the
  // public A/B resolver so the merchant viewing their own dashboard isn't
  // attributed to a running test.
  list: async (storeId: string, page = 'home') => {
    const res = await client.get<ApiResponse<{ sections: PageSection[]; page: string }>>(
      `/store/${storeId}/sections`,
      { params: { page, noAB: 1 } },
    );
    return res.data.data?.sections ?? [];
  },

  // Whole-page save. The backend atomically replaces the active version's
  // sections array with what we send (single updateOne with $set). _id is
  // synthesized server-side from array position; strip any client copy.
  save: async (storeId: string, page: string, sections: PageSection[]) => {
    const stripped = sections.map(({ _id: _ignore, ...rest }) => rest);
    const res = await client.post<ApiResponse<{ saved: number; versionId: string }>>(
      `/store/${storeId}/sections`,
      { page, sections: stripped },
    );
    return res.data.data?.saved ?? 0;
  },
};
